import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map, Observable, of, switchMap } from 'rxjs';
import { PICFLOW_STORYBLOK } from '../picflow-storyblok';
import { ConversionFormat } from '../tools/convert/interfaces/convert';

export const storyblokToolsConvertFormatsResolver: ResolveFn<Observable<ConversionFormat[]>> = route => {
  const storyblokService = inject(PICFLOW_STORYBLOK);

  return storyblokService.getUniqueComponentsList(route).pipe(
    switchMap(components => {
      if (components.has('convert_from_format_list')) {
        return storyblokService
          .getStories({
            content_type: 'image_format',
            excluding_fields: 'longDescription,mainVisual,ogImage,convertIcon,downloadIcon,uploadIcon',
          })
          .pipe(map(resp => resp.stories)) as Observable<ConversionFormat[]>;
      }
      return of(undefined);
    })
  );
};
